<template>
  <div class="info-cards-container">
    <div v-for="card in cardsItems" :key="card.key" class="info-card">
      <info-card :title="card.title" :description="card.value" :tooltip="card.tooltip" :card-key="card.key">
        <template v-if="card.key === 'target'" slot="additional-content"> </template>
      </info-card>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { getProductFormatTypeLabel } from '@/modules/mobile/ofertas/helpers/productType.js'
import InfoCard from '@/components/campaigns/InfoCard.vue'

export default {
  name: 'CampaignInfoCards',
  components: {
    InfoCard,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    products: {
      type: Array,
      default: () => [],
    },
    offerType: {
      type: String,
      validator: (value) =>
        [
          'general',
          'percentage',
          'dynamic_pricing_percentage',
          'takepay',
          'combo',
          'cashback_percentage',
          'cashback_absolute',
          'points',
          'nextbuycashback',
          'dynamic_rule',
          'crosssell',
        ].includes(value),
    },
  },
  computed: {
    cardsItems() {
      return [
        {
          key: 'validity-period',
          title: 'Período de validade',
          value: `${DateTime.fromFormat(this.campaign.start_date.toString(), 'yyyy-MM-dd').toFormat('dd/MM/yyyy')} - ${DateTime.fromFormat(
            this.campaign.end_date.toString(),
            'yyyy-MM-dd'
          ).toFormat('dd/MM/yyyy')}`,
          tooltip: '',
          hasSlot: false,
        },
        ...(this.isIndustry
          ? [
              {
                key: 'campaign-industry',
                title: 'Indústria',
                value: this.campaign.industry.name,
                tooltip: '',
                hasSlot: false,
              },
            ]
          : [
              {
                key: 'campaign-template',
                title: 'Modelo de campanha',
                value: this.campaign.activatable ? 'Ativável' : 'Livre',
                tooltip: '',
                hasSlot: false,
              },
            ]),
        {
          key: 'campaign-format',
          title: 'Formato',
          value: this.getOfferType,
          tooltip: '',
          hasSlot: false,
        },
        ...(this.isIndustry && this.offerType === 'nextbuycashback'
          ? [
              {
                key: 'cashback-expiration-date',
                title: 'Validade do Cashback',
                value: `${DateTime.fromISO(this.campaign?.next_buy_cashback_offer_sales?.[0]?.cashback_expiration_date).toFormat('dd/MM/yyyy')}`,
                tooltip: '',
                hasSlot: false,
              },
            ]
          : []),
        ...(this.offerType === 'dynamic_rule'
          ? [
              {
                key: 'voucher-type',
                title: 'Tipo do Voucher',
                value: this.formatVoucher(this.campaign?.dynamic_rule_offer_sales?.[0]?.benefits?.type),
                tooltip: '',
                hasSlot: false,
              },
            ]
          : [
              {
                key: 'target',
                title: 'Público alvo',
                value: this.campaign.segments.length >= 1 ? this.campaign.segments[0].name : 'Não segmentada',
                tooltip: '',
                hasSlot: false,
              },
            ]),
        {
          key: 'units',
          title: 'Lojas participantes',
          value: `${this.campaign.units.length} loja${this.campaign.units.length !== 1 ? 's' : ''}`,
          hasSlot: false,
        },
        {
          key: 'products',
          title: 'Produtos',
          value: `${this.products.length} produto${this.products.length !== 1 ? 's' : ''}`,
          tooltip: '',
          hasSlot: false,
        },
      ]
    },
    isIndustry() {
      return Boolean(this.campaign.industry)
    },
    getOfferType() {
      if (!this.campaign.types) return '-'
      return this.campaign.types.length > 1 ? 'Múltiplos' : getProductFormatTypeLabel(this.offerType)
    },
  },
  methods: {
    formatVoucher(voucher) {
      return voucher ? voucher[0].toUpperCase() + voucher.substr(1).toLowerCase() : ''
    },
  },
}
</script>

<style scoped lang="scss">
.info-cards-container {
  width: 100%;
  padding: 0 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  align-items: center;
  .info-card {
    min-width: 400px;
    min-height: 100px;
  }
}
.segments-text {
  span {
    color: $cinza-d10;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
  }
}
</style>
